import slick from "slick-carousel";
(() => {
  const sliderWrapper = $(".academy__slider");
  const apiUrl = sliderWrapper.data('url');
  const apiKey = sliderWrapper.data('key') || "jXP+9HWYmrkeWXDLvuv6R0PZAhn5yyS9";
  let academyUrl = sliderWrapper.data('academyUrl') || "https://academy.tytan.com/pl/trainings/";

  if (!apiUrl) {
    return;
  }

  if (!academyUrl.endsWith('/')) {
    academyUrl += '/';
  }

  // original URL: "https://api-tytan-pl.affee360.com/offers?isVisible=true&populate%5B%5D=image&fields%5B%5D=offerTitle&fields%5B%5D=image.href&pagequantity=4&fields%5B%5D=createdAt&sortby=dateTimeStart&fields%5B%5D=dateTimeStart&sorttype=asc&pagenumber=1&fields%5B%5D=category.name&populate%5B%5D=category&filterOld=true&type=ONLINE"
  const url = apiUrl;
  const options = {
    method: "GET",
    headers: {
      "X-API-KEY": apiKey
    }
  };

  function dayMonth(dateString) {
    const date = new Date(dateString);
    const month = new Intl.DateTimeFormat(undefined, { month: "short" }).format(
      date
    );
    const day = new Intl.DateTimeFormat(undefined, { day: "2-digit" }).format(
      date
    );

    return `
      <div>${day}</div>
      <div>${month}</div>
    `;
  }

  function displayPosts(data) {
    if (data["offers"] && data["offers"].length) {
      const blocksHTML = data["offers"].map(
        item => `
          <div class="academy__slide">
            <a href="${academyUrl}${item.id}" target="_blank">
              <div class="academy__date">
                ${dayMonth(item.dateTimeStart)}
              </div>
              <div class="academy__img-wrapper">
                <img src="${item.image.href + ".300.webp"}">
              </div>
              <div class="academy__block-text-wrapper">
                <div class="academy__block-text-top">
                    <div href="${academyUrl}${item.id}" class="academy__academy-link" target="_blank">
                      Webinar
                    </div>
                  <div class="academy__category">
                    ${item.category.name}
                  </div>
                </div>
                <div class="academy__block-text">
                  ${item.offerTitle}
                </div>
              </div>
            </a>
          </div>
        `
      );

      return blocksHTML;
    }
  }

  if (sliderWrapper.length) {
    fetch(url, options)
      .then(response => {
        if (!response.ok) {
          throw new Error("Network response error");
        }

        return response.json();
      })
      .then(data => {
        sliderWrapper.html(displayPosts(data));
        sliderWrapper.slick({
          speed: 600,
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: false,
          variableWidth: true,
          prevArrow:
            '<span class="academy__arrow academy__arrow--prev"></span>',
          nextArrow:
            '<span class="academy__arrow  academy__arrow--next"></span>',
          responsive: [
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      })
      .catch(error => console.error("There has been a problem: ", error));
  }
})();
